import { render, staticRenderFns } from "./ProgressDetail.vue?vue&type=template&id=48c33ef4&scoped=true"
import script from "./ProgressDetail.vue?vue&type=script&lang=js"
export * from "./ProgressDetail.vue?vue&type=script&lang=js"
import style0 from "./ProgressDetail.vue?vue&type=style&index=0&id=48c33ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c33ef4",
  null
  
)

export default component.exports